import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import {trimUndefinedFromObject} from '../../common/util/trimUndefinedFromObject';
import type {WriteCommentInput} from '../../graphql/generated/types';

/**
 * 댓글 작성
 *
 * Origin: pageNicolasApi.writeComment
 * API: POST /api/v5/store/community/write/comment
 */
export async function postStoreCommunityWriteComment(
  writeCommentInput: WriteCommentInput,
  options?: FetcherOptions
): Promise<
  ApiResultVo & {
    user_comment_block_msg?: string;
  }
> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v5/store/community/write/comment',
    {
      method: 'POST',
      data: trimUndefinedFromObject({
        seriesid: writeCommentInput.seriesId,
        collection_uid: writeCommentInput.collectionUid,
        singleid: writeCommentInput.productId,
        comment: writeCommentInput.comment,
        is_spoiler: writeCommentInput.isSpoiler,
        parentuid: writeCommentInput.parentUid,
        emoticon: writeCommentInput.emoticon,
      }),
    },
    options
  );

  return response.data;
}
